import { Vector3 } from "three";
const TendonToVector = (tendon) => {
  return new Vector3(...tendon.points[1]).sub(new Vector3(...tendon.points[0]));
};
export {
  TendonToVector
};
//# sourceMappingURL=index57.js.map
